// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ResetPasswordRequestModel {
    static getAttributeTypeMap() {
        return ResetPasswordRequestModel.attributeTypeMap;
    }
}
ResetPasswordRequestModel.discriminator = undefined;
ResetPasswordRequestModel.additionalProperties = false;
ResetPasswordRequestModel.attributeTypeMap = [
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
];
//# sourceMappingURL=resetPasswordRequestModel.js.map